import React, { useMemo } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import FrontpageMain from './FrontpageMain';
import Rewards from './Rewards';
import ProfilePage from './ProfilePage';

export default function DashboardEntry(props) {
  const location = useLocation();

  const tab = useMemo(() => {
    const p = new URLSearchParams(location.search);
    return (p.get('tab') || 'home').toLowerCase();
  }, [location.search]);

  if (tab === 'free-coins') {
    return <Navigate to="/dashboard?tab=home" replace />;
  }

  if (tab === 'rewards') {
    return <Rewards {...props} />;
  }

  const profileTabs = ['profile', 'settings', 'affiliates', 'cases', 'betting-history', 'transactions'];
  if (profileTabs.includes(tab) || tab === 'earn-with-us') {
    return <ProfilePage {...props} initialTab={tab === 'earn-with-us' ? 'affiliates' : tab} />;
  }

  // For the "home" tab, render the exact frontpage.html main section.
  if (tab === 'home') {
    return <FrontpageMain {...props} />;
  }

  // Keep the rest of your existing dashboard (logic unchanged).
  return <Dashboard />;
}

